'use strict';

import { isElement, forEach, debounce } from 'lodash';
import { subscribe } from '../../01-helpers/event-manager';
import { get as getBookerOptions } from '../../01-helpers/utilities/options';
import { CARD_ADDED } from '../../02-const/event-names';
import { getLocalStorage } from '../../01-helpers/session-manager';

/* ========================================================================== */

const moduleName = 'book-teetime',
	selectors = {
		base: `.js-${moduleName}`,
		submit: `.js-${moduleName}-submit`,
		otherPlayers: `.js-${moduleName}-player`,
		golfertype: '#golfertype',
		phone: '#phone',
        consent: '#consent',
		newsletter: '#newsletter',
		cardInput: 'cardInput',
		playerType: 'PlayerType'
	},
	keys = {
		booker: 'Booker',
		teeTime: 'TeeTime',
		otherPlayers: 'OtherPlayers'
	};

/* ========================================================================== */

let otherPlayers = [];

export class BookTeetime {
	constructor(baseElement) {
		if (!isElement(baseElement)) {
			console.error(`Element has not been found!!.`);

			return;
		}

		this.baseElement = baseElement;
		this.submitElement = this.baseElement.querySelector(selectors.submit);

		this._bindEvents();
	}

	_bindEvents() {
		this.submitElement.addEventListener('click', this._onSubmitHandler);
	}

	_onSubmitHandler(evt) {
		evt.preventDefault();
		evt.stopPropagation();

		//create / get json before submitting the complete form
		const result = {},
			form = evt.currentTarget.closest('form'),
			jsonInput = form.querySelector('input[name="json"]'),
			golfertypeInput = form.querySelector(selectors.golfertype),
			phoneInput = form.querySelector(selectors.phone),
			consentInput = form.querySelector(selectors.consent),
            newsletterInput = form.querySelector(selectors.newsletter),
			booker = getBookerOptions(keys.booker);

		booker[golfertypeInput.name] = golfertypeInput.value;
		booker[phoneInput.name] = phoneInput.value;
		if (isElement(consentInput)) {
			booker[consentInput.dataset.name] = consentInput.checked;
        }

        if (isElement(newsletterInput)) {
            booker[newsletterInput.dataset.name] = newsletterInput.checked;
        }
		result[keys.booker] = booker;
		result[keys.teeTime] = getLocalStorage(keys.teeTime);

		let otherPlayerJson = [];
		forEach(document.querySelectorAll(selectors.otherPlayers), (playerElement) => {
			const playerName = playerElement.querySelector(`[name^='${selectors.cardInput}']`),
				playerTypeSelection = playerElement.querySelector(`[name='${selectors.playerType}']`);

			otherPlayerJson.push(
				JSON.parse(`{
					"Name": "${playerName.value}",
					"ImgUrl": "${playerName.dataset?.ImgUrl}",
					"PlayerType": "${playerTypeSelection.value}"
				}`)
			);
		});	

		result[keys.otherPlayers] = otherPlayerJson;

		jsonInput.value = JSON.stringify(result);
		// submit form
		form.submit();
	}
}

const initBookTeetime = () => {
	forEach(document.querySelectorAll(selectors.base), (bookElement) => {
		const booking = new BookTeetime(bookElement);
	});
};

initBookTeetime();
